<!--
 * @Author: your name
 * @Date: 2021-04-22 11:29:07
 * @LastEditTime: 2021-05-18 09:53:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/index.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="list">品牌合同列表</el-menu-item>
          <el-menu-item index="add">创建品牌合同</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <!-- 品牌合同列表 -->
        <brandContractList v-if="activeIndex == 'list'"></brandContractList>
        <!-- 创建品牌合同 -->
        <addBrandContract v-if="activeIndex == 'add'" contractType="add"></addBrandContract>
      </div>
    </div>
  </div>
</template>

<script>
import brandContractList from './component/list'
import addBrandContract from './add'
export default {
  data() {
    return {
      activeIndex: "list",
    };
  },
  components: {
    addBrandContract,
    brandContractList
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
  },
}
</script>